import type { TabProps, TabState } from "./Tab.types";
import { useAriaControls } from "@1js/acui-hooks";
import { getRibbonBottomBarAriaControlsId } from "../../Ribbon/Ribbon.Props";
import { getRibbonTopBarStylingConstants } from "../../../ribbonStylingConstants";
import { ribbonTabCSSVars } from "./useTabStyles.styles";

const { ribbonTabHeight } = ribbonTabCSSVars;

export const useTabState = (props: TabProps, state: TabState): TabState => {
  useAriaControls(
    state,
    state.selected ? getRibbonBottomBarAriaControlsId(props.id) : undefined
  );

  const rootVariables = {
    // Height of the top bar and account for 2px margin top/bottom
    [ribbonTabHeight]: `${
      getRibbonTopBarStylingConstants().tabHeaderHeight - 4
    }px`,
  };

  // Root props
  state.root.style = {
    ...rootVariables,
    ...state.root.style,
  };

  return state;
};
